import React from "react";
import "../Delete/DeleteGroup.css";
import axios from "../../axios";
import { IP } from "../../internalServer";

import { useState } from "react";

import SuceesMemberDeleteMsg from "../SucessGroup/SuceesMemberDeleteMsg";

// css comes from CreateMoreGroups.css

export default function DeleteGroupMember({ setMember, data, list }) {
  const [click, setClick] = useState();

  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  async function cancle() {
    try {
      const data1 = {
        teacher_id,
        members: [
          data?.member?.id
        ]
      }
      console.log(data1)
      const res = await axios.delete(`api/v1/group/removeMember/${list.id}`, {
        data: data1 
      });
      res && setClick(true);
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <>
      {!click && (
        <div className="deleteMemberGroupAll">
          <div className="delete_group_sub_main  ">
            <div className="d-flex">
              <img
                className="group_profile_img"
                src={IP + data.member.profile_picture.replace(/^\./, "")}
                alt=""
              ></img>
              <div className="deleteMemName">
                <div className="class_group">{data?.member?.name}</div>
                {/* <div className="parent_group_member">{list?.description}</div> */}
              </div>
            </div>
            <div className="group_Deletemsg">
              Are you sure you want to delete this Member?
            </div>

            <div className="btn_Yes_no_all  ">
              <div>

                <button
                  onClick={(e) => { cancle(); }}
                  className="yes_btn_group "
                >
                  Yes
                </button>

              </div>
              <div>
                <button
                  onClick={(e) => setMember(false)}
                  className="No_btn_group "
                >
                  No
                </button>
              </div>
            </div>
          </div>
          {/* <Link to='/createMoreGroups'> */}
          <img
            src="/group-img/CrossIconGroup.svg"
            className="delet_icon_For_g"
            alt=""
            onClick={(e) => setMember(false)}
          />
          {/* </Link> */}
        </div>
      )}
      {click && (
        <SuceesMemberDeleteMsg change={setClick} setMember={setMember} />
      )}
    </>
  );
}
